import { InstanceManager } from "../Data/InstanceManager";
import { useEffect } from "react";

export const useDbReadyEvent = (callback: () => void) => {
	useEffect(() => {
		InstanceManager.db.Ready().then(callback);
	}, []);
};
